enum RecipientsWizardTabs {
    Recipient = "Recipient",
    Bank = "Bank",
    Address = "Address",
}

export default RecipientsWizardTabs;